import React from 'react';
import { Card, CardTitle, CardContent, Typography, Button, CardActions, } from '@one-thd/sui-atomic-components';
import { QUOTE_LIST_PATH } from '../../constants/links';
import { dashboardComponentClickAnalytics } from '../../utils/dashboard-analytics';
export var JobQuotesCard = function () {
    var cardTitleHeader = (React.createElement(Typography, { height: "tight", variant: "h3", weight: "bold" }, "Job Quotes"));
    return (React.createElement(Card, { grow: true, PaperProps: { className: 'sui-flex sui-h-full' } },
        React.createElement(CardTitle, { header: cardTitleHeader, disableActionSpacing: true }),
        React.createElement(CardContent, { className: "sui-flex sui-overflow-hidden sui-flex-row sui-justify-between sui-h-full" },
            React.createElement("div", { className: "sui-flex sui-flex-col" },
                React.createElement(Typography, null, "Create new quotes as you shop to lock in product pricing, collaborate with Pro Associates and share with your team and clients."))),
        React.createElement(CardActions, null,
            React.createElement(Button, { fullWidth: true, variant: "secondary", href: QUOTE_LIST_PATH, onClick: function () {
                    return dashboardComponentClickAnalytics({
                        component: 'job quotes',
                        subComponent: 'manage quotes',
                    });
                } }, "Manage Quotes"))));
};
